import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';

const StyledSaleBadge = styled(GatsbyImage)``;

const SaleBadge = ({ ...props }) => {
  const {
    datoCmsSale: { badge },
  } = useStaticQuery(graphql`
    query SaleBadgeQuery {
      datoCmsSale {
        badge {
          url
          gatsbyImageData(width: 100, height: 100)
          alt
          format
        }
      }
    }
  `);

  return (
    badge && (
      <StyledSaleBadge
        {...(badge.format === 'svg'
          ? {
              as: 'img',
              src: badge.url,
            }
          : {
              image: badge.gatsbyImageData,
            })}
        alt={badge.alt}
        loading="lazy"
        {...props}
      />
    )
  );
};

export default SaleBadge;
